module.exports = __webpack_public_path__ + "static/media/logo.9c9919d6.svg";